import DOMPurify from 'dompurify';

const EMPTY_EDITOR_HTML = new Set(['', '<p></p>', '<div></div>', '<p><br></p>', '<div><br></div>', '<p>&nbsp;</p>']);

export const sanitizeHtml = (html: string): string => DOMPurify.sanitize(html ?? '', { ADD_ATTR: ['target'] });

export const sanitizeEditorHtml = (html: string | null): string | null => {
    const trimmed = (html ?? '').trim();
    return EMPTY_EDITOR_HTML.has(trimmed) ? null : sanitizeHtml(trimmed);
};
